import axios from 'axios';

export default {
  // Admin
  getAdminRoles: (data) => {
    return axios.get('/api/admin/roles', data)
      .then(response => ({
        roles: response.data.roles != null
          ? response.data.roles : {},
        permissions: response.data.permissions != null
          ? response.data.permissions : {},
        tenants: response.data.tenants != null
          ? response.data.tenants : {},
      }));
  },

  getPartnerRoles: (data) => {
    return axios.get('/api/c/roles', data)
      .then(response => ({
        roles: response.data.roles != null
          ? response.data.roles : {},
        permissions: response.data.permissions != null
          ? response.data.permissions : {},
        tenants: response.data.tenants != null
          ? response.data.tenants : {},
      }));
  },
};
